import React from 'react';
import IntlMessages from '../components/IntlMessage';
import {
  AccountBookOutlined,
  BarChartOutlined,
  BranchesOutlined,
  CalendarOutlined,
  CarOutlined,
  CustomerServiceOutlined,
  EnvironmentOutlined,
  FundProjectionScreenOutlined,
  HomeOutlined,
  LineChartOutlined,
  LockOutlined,
  NodeIndexOutlined,
  PieChartOutlined,
  SettingOutlined,
  ShareAltOutlined,
  ShoppingOutlined,
  TableOutlined,
  UsergroupAddOutlined,
} from '@ant-design/icons';

const menu = [
  {
    key: '/app/revenue',
    label: <IntlMessages id="global.dashboard" />,
    icon: <LineChartOutlined />,
    permission: null,
    children: null,
  },

  // {
  //   key: "/app/booking",
  //   label: <IntlMessages id="global.orders" />,
  //   icon: <ShoppingOutlined />,
  //   permission: null,
  //   children: null,
  // },
  // {
  //   key: "/app/customer",
  //   label: <IntlMessages id="global.customers" />,
  //   icon: <CustomerServiceOutlined />,
  //   permission: null,
  //   children: null,
  // },

  // {
  //   key: "/app/routes",
  //   label: <IntlMessages id="sidebar.routes" />,
  //   icon: <BranchesOutlined />,
  //   permission: null,
  //   children: [
  //     {
  //       key: "/app/route",
  //       label: <IntlMessages id="sidebar.routes" />,
  //       icon: <BranchesOutlined />,
  //       permission: null,
  //       children: null,
  //     },
  //     {
  //       key: "/app/seatmap",
  //       label: <IntlMessages id="sidebar.seatmap" />,
  //       icon: <TableOutlined />,
  //       permission: null,
  //       children: null,
  //     },
  //     {
  //       key: "/app/vehicles",
  //       label: <IntlMessages id="sidebar.vehicles" />,
  //       icon: <CarOutlined />,
  //       permission: null,
  //       children: null,
  //     },
  //   ],
  // },
  {
    key: '/app/report',
    label: <IntlMessages id="global.orders" />,
    icon: <EnvironmentOutlined />,
    permission: null,
    children: [
      {
        key: '/app/report/booking',
        label: <IntlMessages id="global.orders" />,
        icon: <CalendarOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/report/booking_statistics',
        label: <IntlMessages id="global.booking_statistics" />,
        icon: <CalendarOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/report/sales',
        label: <IntlMessages id="global.sales" />,
        icon: <ShoppingOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/report/trips',
        label: <IntlMessages id="global.trips" />,
        icon: <LockOutlined />,
        permission: null,
        children: null,
      },
    ],
  },

  // {
  //   key: "/app/cashier",
  //   label: <IntlMessages id="global.sales" />,
  //   icon: <PieChartOutlined />,
  //   permission: null,
  //   children: null,
  // },

  {
    key: '/app/settings',
    label: <IntlMessages id="global.setting" />,
    icon: <SettingOutlined />,
    permission: null,
    children: [
      // {
      //   key: '/app/settings/account',
      //   label: <IntlMessages id="sidebar.account" />,
      //   icon: <ShoppingOutlined />,
      //   permission: null,
      //   children: null,
      // },
      // {
      //   key: '/app/settings/payment',
      //   label: <IntlMessages id="global.payments" />,
      //   icon: <ShoppingOutlined />,
      //   permission: null,
      //   children: null,
      // },
      {
        key: '/app/settings/user',
        label: <IntlMessages id="global.user" />,
        icon: <UsergroupAddOutlined />,
        permission: null,
        children: null,
      },
      {
        key: '/app/settings/depart',
        label: <IntlMessages id="global.depart" />,
        icon: <NodeIndexOutlined />,
        permission: null,
        children: null,
      },
    ],
    // children: [
    //   {
    //     key: '/app/trips/statistics',
    //     label: <IntlMessages id="global.statistics" />,
    //     icon: <FundProjectionScreenOutlined />,
    //     permission: null,
    //     children: null,
    //   },
    //   {
    //     key: '/app/trips/routes',
    //     label: <IntlMessages id="global.routes" />,
    //     icon: <ShareAltOutlined />,
    //     permission: null,
    //     children: null,
    //   },
    // ],
  },
];

export default menu;
